import BaseService from '_services/rest/base';

class QuotationService extends BaseService {
  constructor() {
    super();
  }

  duplicate(quotationId) {
    return this.request(`${this.getUrl()}/duplicate/${quotationId}`, null, 'POST')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  deleteQuotation(id) {
    return this.request(`${this.getUrl()}/${id}`, null, 'DELETE')
      .catch(err => {
        throw err;
      });
  }

  deleteTemplate(id) {
    return this.request(`${this.getUrl()}/template/${id}`, null, 'DELETE')
      .catch(err => {
        throw err;
      });
  }

  deleteDrives(id) {
    return this.request(`${super.getUrl()}/api/drive/${id}`, null, 'DELETE')
      .catch(err => {
        throw err;
      });
  }

  deleteQuotationFile(param) {
    return this.request(`${this.getUrl()}/${param.quotationId}/file/${param.fileId}`, null, 'DELETE')
      .catch(err => {
        throw err;
      });
  }

  getUrl() {
    return `${super.getUrl()}api/quotation`;
  }

  getUrlPdf() {
    return `${super.getUrl()}api/pdf`;
  }

  getQuotationPreviewUrl(id) {
    return `${super.getUrl()}quotation/${id}`;
  }

  getQuotationDownloadUrl(id) {
    return `${this.getUrlPdf()}/quotation/${id}`;
  }

  getUrlSave(id, url = '') {
    if (id) {
      return {
        url: `${this.getUrl()}${url}/${id}`,
        method: 'PUT',
      };
    }
    return {
      url: `${this.getUrl()}${url}`,
      method: 'POST',
    };
  }

  getContract(id) {
    return this.request(`${this.getUrl()}/${id}/contract`)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  getUrlCommentSave(quotationId, id) {
    if (id) {
      return {
        url: `${this.getUrl()}/${quotationId}/comment/${id}`,
        method: 'PUT',
      };
    }
    return {
      url: `${this.getUrl()}/${quotationId}/comment`,
      method: 'POST',
    };
  }

  getStatus() {
    return this.request(`${this.getUrl()}/status`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getList(params) {
    return this.request(`${this.getUrl()}/all/${params.skip}/${params.take}`, params)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getTemplateList(params) {
    const skip = params && params.skip ? params.skip : 0;
    const take = params && params.take ? params.take : 10;
    return this.request(`${this.getUrl()}/template/all/${skip}/${take}`, params)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getModelList(params) {
    const filters = { search: params.search };

    return this.request(`${this.getUrl()}/model/all/${params.skip}/${params.take}`, filters)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getPaymentTypeOptions() {
    return this.request(`${this.getUrl()}/payment-type`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getPriorities() {
    return this.request(`${this.getUrl()}/priorities/`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getTypeOptions() {
    return this.request(`${this.getUrl()}/type`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getClassOptions() {
    return this.request(`${this.getUrl()}/class/all`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getDrivesOptions() {
    return this.request(`${super.getUrl()}api/drive`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getQuotationById(id) {
    return this.request(`${this.getUrl()}/${id}`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getTemplateById(id) {
    return this.request(`${this.getUrl()}/template/${id}`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getQuotationTemplate(id) {
    return this.request(`${this.getUrl()}/template/${id}/formatted`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  createTemplateFromQuotation(quotationId, template) {
    return this.request(`${this.getUrl()}/${quotationId}/template`, template, 'POST')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  print(id) {
    return this.request(`${this.getUrlPdf()}/quotation/${id}`, null, 'GET', 'arraybuffer')
      .catch(err => {
        throw err;
      });
  }

  printTechnicalAvaliation(id) {
    return this.request(`${this.getUrlPdf()}/technical-avaliation/${id}`, null, 'GET', 'arraybuffer')
      .catch(err => {
        throw err;
      });
  }

  viewPdf(id) {
    return this.request(`${this.getUrlPdf()}/contract/${id}`, null, 'GET', 'arraybuffer')
      .catch(err => {
        throw err;
      });
  }

  declineQuotation(id) {
    return this.request(`${this.getUrl()}/${id}/declined`, null, 'patch')
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  approveQuotation(model) {
    return this.request(`${this.getUrl()}/${model.id}/approved`, model, 'post')
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  paidQuotation(model) {
    return this.request(`${this.getUrl()}/${model.id}/approved-payment`, model, 'post')
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  pendingQuotation(model) {
    return this.request(`${this.getUrl()}/${model.id}/pending-payment`, model, 'post')
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  approveAdminQuotation(id) {
    return this.request(`${this.getUrl()}/${id}/approved-admin`, null, 'post')
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  save(quotation) {
    const meta = this.getUrlSave(quotation.id);
    return this.request(meta.url, quotation, meta.method)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  saveTemplate(template) {
    const meta = this.getUrlSave(template.id, '/template');
    return this.request(meta.url, template, meta.method)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  saveCustomer(quotation) {
    return this.request(`${this.getUrl()}`, quotation, 'post')
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  saveFile(params) {
    const formData = new FormData();
    formData.append('file', params.file);
    formData.append('file_type', params.file_type);
    return this.request(`${this.getUrl()}/${params.id}/file`, formData, 'POST')
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  updateQuotation(quotation) {
    return this.request(`${this.getUrl()}/${quotation.id}`, quotation, 'put')
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  sendComment(params) {
    const meta = this.getUrlCommentSave(params.quotation_id, params.comment.id);
    return this.request(meta.url, params.comment, meta.method)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  saveDrives(drive) {
    return this.request(`${super.getUrl()}api/drive`, drive, 'post')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  saveQuotationTypes(types) {
    return this.request(`${this.getUrl()}/type`, types, 'PUT')
      .catch(err => {
        throw err;
      });
  }

  saveQuotationContractualItems(params) {
    return this.request(`${this.getUrl()}/${params.id}/contract-items/`, params, 'POST')
      .catch(err => {
        throw err;
      });
  }

  filterSelected(model) {
    model.variation_clause = model.variation_clause.filter(item => item.selected);
    model.obligation_hired = model.obligation_hired.filter(item => item.selected);
    model.obligation_contractor = model.obligation_contractor.filter(item => item.selected);
    return model;
  }

  saveContract(model) {
    const meta = this.getUrlSave(model.id);
    const obligations = this.filterSelected(model);
    return this.request(`${this.getUrl()}/${model.quotation_id}/contract`, obligations, meta.method)
      .then(response => response.data);
  }

  sendMessage(params, type = '') {
    return this.request(`${this.getUrl()}/${params.quotation_id}${type}/send/email`, params, 'POST')
      .catch(err => {
        throw err;
      });
  }

  sendMessageWhats(params, type = '') {
    return this.request(`${this.getUrl()}/${params.quotation_id}${type}/send/whatsapp`, params, 'POST')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  saveQuotationPaymentTypes(paymentTypes) {
    return this.request(`${this.getUrl()}/payment-type`, paymentTypes, 'PUT')
      .catch(err => {
        throw err;
      });
  }

  assingQuotation(id, params) {
    return this.request(`${this.getUrl()}/${id}/assign`, params, 'POST')
      .catch(err => {
        throw err;
      });
  }

  updateStatus(quotationId, status, markAsSent = false) {
    return this.request(`${this.getUrl()}/${quotationId}/status`, { status, markAsSent }, 'PUT')
      .catch(err => {
        throw err;
      });
  }

  setDefaultGroup(quotationId, groupId) {
    return this.request(`${this.getUrl()}/${quotationId}/group/${groupId}`, null, 'PATCH')
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  updatePriority(quotationId, priorityId) {
    return this.request(`${this.getUrl()}/${quotationId}/priority`, priorityId, 'patch')
      .catch(err => {
        throw err;
      });
  }

  getUpdatedRows(params) {
    const filters = { priceTable: params.priceTable };
    return this.request(`${this.getUrl()}/${params.id}/updated-rows`, filters)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }
}

export default new QuotationService();
